import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/consumer/Link';
import { data } from './data';
const PDPValuePropsModalUI = t0 => {
  const $ = _c(15);
  const {
    itemId
  } = t0;
  const item = data[itemId];
  if (!item) {
    return null;
  }
  let t1;
  if ($[0] !== item.rows || $[1] !== itemId) {
    t1 = item.rows && item.rows.map(row => <div key={itemId + row.title} className="mb-8"><h3 className="text-lg font-bold m-0 text-brand-lightest">{row.title}{" "}{row.superscript && <span><sup>{row.superscript}</sup></span>}</h3>{row.text && <p className="text-sm text-brand-lightest">{row.text}</p>}</div>);
    $[0] = item.rows;
    $[1] = itemId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== item.paras || $[4] !== itemId) {
    t2 = item.paras && item.paras.map(para => <p key={itemId + para.slice(0, 5)} className="mt-0 mx-0 mb-4">{para}</p>);
    $[3] = item.paras;
    $[4] = itemId;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== item.terms) {
    t3 = item.terms && <p className="mt-6 mx-0 mb-0 text-xs text-brand-lightest">{item.terms}</p>;
    $[6] = item.terms;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== item.footer) {
    t4 = item.footer && <div className="text-xs text-brand-lightest mt-2 [&_a]:text-brand-lightest [&_a]:font-normal [&_a]:no-underline">See our{" "}<span className="[border-bottom:1px_solid_#737373]"><Link to="/returns/" target="_blank">full returns policy</Link></span>{" "}for more details</div>;
    $[8] = item.footer;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t1 || $[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <div className="mt-4">{t1}{t2}{t3}{t4}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
PDPValuePropsModalUI.propTypes = {
  itemId: PropTypes.string
};
export default PDPValuePropsModalUI;